import React from "react";
import { Typography, Select, MenuItem, Box } from "@mui/material";

const Project = ({ projects, dropdown1Value, handleDropdown1Change }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <Box
          sx={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: dropdown1Value ? "green" : "gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", color: "white" }}
          >
            1
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Select Project
        </Typography>
      </Box>
      <Select
        defaultValue="seke"
        value={dropdown1Value}
        onChange={handleDropdown1Change}
        sx={{ marginBottom: 6, width: "100%" }}
      >
        {projects?.map((project) => (
          <MenuItem
            key={project.id}
            selected={project.name === dropdown1Value}
            value={project}
          >
            {project.name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default Project;
